import Vue from 'vue';
import VButton from '@/components/v-button';
import VModal from '@/components/v-modal';
import VDialog from '@/components/v-dialog';
import VBottomModal from '@/components/v-bottom-modal';
import VLinkItem from '@/components/v-link-item';
import VCheck from '@/components/v-check';
import VKeyboard from '@/components/v-keyboard';
import VFloor from '@/components/v-floor';
import VCloseView from '@/components/v-close-view';
import VFace from '@/components/v-face';
import VLoading from '@/components/v-loading';
import VCollapse from '@/components/v-collapse';
import VTab from '@/components/v-tab';
import VCloseDialog from '@/components/v-close-dialog';

Vue.use(VButton);
Vue.use(VModal);
Vue.use(VDialog);
Vue.use(VBottomModal);
Vue.use(VLinkItem);
Vue.use(VCheck);
Vue.use(VKeyboard);
Vue.use(VFloor);
Vue.use(VCloseView);
Vue.use(VFace);
Vue.use(VLoading);
Vue.use(VCollapse);
Vue.use(VTab);
Vue.use(VCloseDialog);